/* Yes Oro – JS global (vanilla, sin dependencias). Cabecera, megamenús, búsqueda predictiva,
   menú móvil, carrito lateral, avisos, hero, frase de marca y secciones diferidas. */
(() => {
  const YO = window.YO || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesk = () => window.matchMedia('(min-width: 820px)').matches;
  // SKU con o sin guion: "I621" -> "I-621" y "I-621" -> "I621". Devuelve null si no parece un SKU.
  YO.skuAlterno = (q) => {
    const m = String(q).trim().match(/^([A-Za-z]{1,3})(-?)(\d{3,})$/);
    return m ? m[1] + (m[2] ? '' : '-') + m[3] : null;
  };
  window.YO = YO;
  const announce = (msg) => { const r = $('#YoLiveRegion'); if (r) { r.textContent = ''; setTimeout(() => { r.textContent = msg; }, 50); } };

  /* ---------- Focus trap ---------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  let trapEl = null, trapReturn = null;
  const onTrapKey = (e) => {
    if (!trapEl || e.key !== 'Tab') return;
    const f = $$(FOCUSABLE, trapEl).filter((el) => el.offsetParent !== null || el === document.activeElement);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  const trapFocus = (el, focusEl) => { trapEl = el; trapReturn = document.activeElement; document.addEventListener('keydown', onTrapKey); (focusEl || $(FOCUSABLE, el) || el).focus(); };
  const releaseFocus = () => { document.removeEventListener('keydown', onTrapKey); trapEl = null; if (trapReturn && trapReturn.focus) trapReturn.focus(); trapReturn = null; };
  window.YO.trapFocus = trapFocus; window.YO.releaseFocus = releaseFocus;

  /* ---------- Barra de avisos ---------- */
  class YoAnnouncement extends HTMLElement {
    connectedCallback() {
      this.msgs = $$('.ann__msg', this); this.i = 0;
      if (this.msgs.length < 2) return;
      $('[data-ann-prev]', this).addEventListener('click', () => this.go(this.i - 1));
      $('[data-ann-next]', this).addEventListener('click', () => this.go(this.i + 1));
      ['mouseenter', 'focusin'].forEach((ev) => this.addEventListener(ev, () => this.stop()));
      ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => this.start()));
      this.start();
    }
    go(n) { this.msgs[this.i].classList.remove('is-active'); this.i = (n + this.msgs.length) % this.msgs.length; this.msgs[this.i].classList.add('is-active'); }
    start() { if (reduced) return; this.stop(); this.t = setInterval(() => this.go(this.i + 1), parseInt(this.dataset.interval, 10) || 5000); }
    stop() { clearInterval(this.t); }
  }
  customElements.define('yo-announcement', YoAnnouncement);

  /* ---------- Cabecera ---------- */
  class YoHeader extends HTMLElement {
    connectedCallback() {
      this.alwaysSolid = this.classList.contains('is-solid');
      this.searchOpen = false; this.openTrigger = null;
      this.triggers = $$('[data-mega-trigger]', this);
      this.search = $('#PredictiveSearch', this);
      this.onScroll = () => this.update();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();

      this.triggers.forEach((t) => {
        const panel = document.getElementById(t.dataset.megaTrigger);
        if (!panel) return;
        t.addEventListener('mouseenter', () => { if (isDesk() && !this.searchOpen) this.openMega(t); });
        t.addEventListener('click', (e) => {
          if (!isDesk() || t.dataset.click !== 'toggle') return;
          e.preventDefault();
          if (t.getAttribute('aria-expanded') === 'true') this.closeMega(); else this.openMega(t, e.detail === 0);
        });
      });
      $$('.hdr__nav > li > a:not([data-mega-trigger])', this).forEach((a) => a.addEventListener('mouseenter', () => this.closeMega()));
      this.addEventListener('mouseleave', () => this.closeMega());
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.openTrigger) { const t = this.openTrigger; this.closeMega(); t.focus(); }
        if (this.searchOpen) this.closeSearch(true);
        const lang = $('[data-lang-toggle]', this); if (lang && lang.getAttribute('aria-expanded') === 'true') this.toggleLang(false);
      });
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) { this.closeMega(); if (this.searchOpen) this.closeSearch(); this.toggleLang(false); }
      });

      /* Idioma */
      const lt = $('[data-lang-toggle]', this);
      if (lt) lt.addEventListener('click', () => this.toggleLang(lt.getAttribute('aria-expanded') !== 'true'));

      /* Búsqueda */
      $$('[data-search-open]', this).forEach((b) => b.addEventListener('click', (e) => {
        if (YO.predictiveSearch === false) return;
        e.preventDefault(); this.searchOpen ? this.closeSearch() : this.openSearch();
      }));
      $('[data-search-close]', this).addEventListener('click', () => this.closeSearch(true));
      this.input = $('[data-predictive-input]', this);
      this.results = $('[data-predictive-results]', this);
      this.popular = $('[data-popular]', this);
      this.clear = $('[data-search-clear]', this);
      this.input.addEventListener('input', () => this.onQuery());
      this.clear.addEventListener('click', () => { this.input.value = ''; this.onQuery(); this.input.focus(); });
      $$('[data-term]', this).forEach((b) => b.addEventListener('click', () => { this.input.value = b.dataset.term; this.onQuery(); this.input.focus(); }));

      /* Menú móvil */
      this.mm = document.getElementById('MobileMenu');
      $$('[data-mm-open]', this).forEach((b) => b.addEventListener('click', () => this.openMM()));
      if (this.mm) {
        $('[data-mm-close]', this.mm).addEventListener('click', () => this.closeMM());
        this.mm.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeMM(); });
        $$('.mm__toggle', this.mm).forEach((b) => b.addEventListener('click', () => {
          const open = b.getAttribute('aria-expanded') === 'true';
          $$('.mm__toggle', this.mm).forEach((o) => { o.setAttribute('aria-expanded', 'false'); document.getElementById(o.getAttribute('aria-controls')).hidden = true; });
          if (!open) { b.setAttribute('aria-expanded', 'true'); document.getElementById(b.getAttribute('aria-controls')).hidden = false; }
        }));
        const wa = $('[data-wa-open]', this.mm);
        if (wa) wa.addEventListener('click', () => { this.closeMM(false); document.dispatchEvent(new CustomEvent('yo:wa-open')); });
      }
    }
    update() {
      const solid = !!(this.alwaysSolid || window.scrollY > 10 || this.openTrigger || this.searchOpen);
      this.classList.toggle('is-solid', solid);
    }
    openMega(t, focusFirst) {
      if (this.openTrigger === t) return;
      this.closeMega(true);
      const panel = document.getElementById(t.dataset.megaTrigger);
      panel.hidden = false; t.setAttribute('aria-expanded', 'true');
      this.openTrigger = t; this.classList.add('has-mega'); this.update();
      if (focusFirst) { const f = $('a', panel); if (f) f.focus(); }
    }
    closeMega(keepState) {
      if (!this.openTrigger) return;
      document.getElementById(this.openTrigger.dataset.megaTrigger).hidden = true;
      this.openTrigger.setAttribute('aria-expanded', 'false');
      this.openTrigger = null;
      if (!keepState) { this.classList.remove('has-mega'); this.update(); }
    }
    toggleLang(open) {
      const lt = $('[data-lang-toggle]', this); if (!lt) return;
      lt.setAttribute('aria-expanded', open ? 'true' : 'false');
      $('#LangList', this).hidden = !open;
    }
    openSearch() {
      this.closeMega(); this.searchOpen = true; this.search.hidden = false; this.update();
      $$('[data-search-open]', this).forEach((b) => b.setAttribute('aria-expanded', 'true'));
      setTimeout(() => this.input.focus(), 20);
    }
    closeSearch(returnFocus) {
      this.searchOpen = false; this.search.hidden = true; this.update();
      $$('[data-search-open]', this).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (returnFocus) { const b = $$('[data-search-open]', this).find((x) => x.offsetParent !== null); if (b) b.focus(); }
    }
    onQuery() {
      const q = this.input.value.trim();
      this.clear.hidden = !q;
      if (this.popular) this.popular.hidden = !!q;
      clearTimeout(this.qt);
      if (!q) { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
      this.qt = setTimeout(() => this.fetchResults(q), 220);
    }
    async fetchResults(q) {
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      const pedir = async (term) => {
        const url = `${YO.routes.predictive}?q=${encodeURIComponent(term)}&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each&resources[options][prefix]=last&section_id=predictive-search`;
        const res = await fetch(url, { signal: this.ctrl.signal });
        if (!res.ok) throw new Error(res.status);
        return new DOMParser().parseFromString(await res.text(), 'text/html');
      };
      try {
        let doc = await pedir(q);
        // SKU escrito con o sin guion (I621 / I-621): si no hay productos, se reintenta con la otra forma.
        const alt = YO.skuAlterno(q);
        if (alt && !doc.querySelector('#PredictiveSearchResults a[href*="/products/"]')) {
          const doc2 = await pedir(alt);
          if (doc2.querySelector('#PredictiveSearchResults a[href*="/products/"]')) doc = doc2;
        }
        const inner = doc.querySelector('#PredictiveSearchResults');
        this.results.innerHTML = inner ? inner.innerHTML : '';
        this.input.setAttribute('aria-expanded', 'true');
      } catch (err) { if (err.name !== 'AbortError') this.results.innerHTML = ''; }
    }
    openMM() {
      this.mm.hidden = false; document.body.classList.add('overflow-hidden');
      $$('[data-mm-open]', this).forEach((b) => b.setAttribute('aria-expanded', 'true'));
      trapFocus(this.mm, $('[data-mm-close]', this.mm));
    }
    closeMM(returnFocus = true) {
      this.mm.hidden = true; document.body.classList.remove('overflow-hidden');
      $$('[data-mm-open]', this).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (returnFocus) releaseFocus(); else { document.removeEventListener('keydown', onTrapKey); trapEl = null; }
    }
  }
  customElements.define('yo-header', YoHeader);

  /* ---------- Carrito ---------- */
  const setCount = (n) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; });
    $$('.hdr__mob [data-cart-open]').forEach((el) => { const lbl = el.getAttribute('aria-label') || ''; el.setAttribute('aria-label', lbl.replace(/\d+/, n)); });
  };
  const cartRequest = async (url, body) => {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || YO.strings.cartError);
    return data;
  };

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-close]')) { this.close(); return; }
        const q = e.target.closest('[data-qty-change]');
        if (q) { const line = q.closest('[data-line]'); this.change(parseInt(line.dataset.line, 10), parseInt(q.dataset.qtyChange, 10), line); }
      });
      this.addEventListener('submit', (e) => {
        const f = e.target.closest('[data-quick-add]'); if (!f) return;
        e.preventDefault(); YO.addToCart(new FormData(f), f.querySelector('button'));
      });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    }
    open() {
      if (this.isOpen) return;
      this.hidden = false; requestAnimationFrame(() => this.setAttribute('open', ''));
      this.isOpen = true; document.body.classList.add('overflow-hidden');
      trapFocus(this, $('[data-cart-close]', $('.cd__head', this)));
    }
    close() {
      if (!this.isOpen) return;
      this.removeAttribute('open'); this.isOpen = false; document.body.classList.remove('overflow-hidden');
      setTimeout(() => { if (!this.isOpen) this.hidden = true; }, reduced ? 0 : 350);
      releaseFocus();
    }
    render(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('#CartDrawerInner');
      if (!inner) return;
      $('[data-cart-content]', this).innerHTML = inner.outerHTML;
      setCount(inner.dataset.count);
      if (this.isOpen) { const c = $('[data-cart-close]', $('.cd__head', this)); trapEl = this; if (c && !this.contains(document.activeElement)) c.focus(); }
    }
    showError(msg) { const e = $('[data-cart-error]', this); e.textContent = msg; e.hidden = !msg; }
    async change(line, quantity, el) {
      if (el) el.classList.add('is-loading');
      this.showError('');
      try {
        const data = await cartRequest(YO.routes.cartChange + '.js', { line, quantity, sections: 'cart-drawer', sections_url: window.location.pathname });
        this.render(data.sections['cart-drawer']);
        announce(`${YO.strings.cartUpdated || ''}`);
      } catch (err) { this.showError(err.message); if (el) el.classList.remove('is-loading'); }
    }
  }
  customElements.define('cart-drawer', CartDrawer);
  const drawer = () => document.getElementById('CartDrawer');

  YO.addToCart = async (formData, button) => {
    const d = drawer();
    const payload = {};
    formData.forEach((v, k) => {
      if (k.startsWith('properties[')) { payload.properties = payload.properties || {}; payload.properties[k.slice(11, -1)] = v; }
      else payload[k] = v;
    });
    const body = { items: [{ id: parseInt(payload.id, 10), quantity: parseInt(payload.quantity || 1, 10), properties: payload.properties }] };
    if (d) { body.sections = 'cart-drawer'; body.sections_url = window.location.pathname; }
    const label = button ? button.innerHTML : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.disabled = true; }
    try {
      const data = await cartRequest(YO.routes.cartAdd + '.js', body);
      if (d && YO.cartType === 'drawer') { d.render(data.sections['cart-drawer']); d.open(); }
      else { window.location.href = YO.routes.cart; }
      return data;
    } catch (err) {
      if (d) { d.showError(err.message); d.open(); }
      throw err;
    } finally {
      if (button) { button.disabled = false; button.removeAttribute('aria-disabled'); button.innerHTML = label; }
    }
  };

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-cart-open]');
    if (!t) return;
    const d = drawer();
    if (!d || YO.cartType !== 'drawer') return;
    e.preventDefault(); d.open();
  });

  /* ---------- WhatsApp ---------- */
  const waRoot = $('[data-wa]');
  if (waRoot) {
    const pop = $('#WhatsAppChooser'), tg = $('[data-wa-toggle]', waRoot);
    const set = (open) => { pop.hidden = !open; tg.setAttribute('aria-expanded', open ? 'true' : 'false'); if (open) { const a = $('a', pop); if (a) a.focus(); } };
    tg.addEventListener('click', () => set(pop.hidden));
    $('[data-wa-close]', pop).addEventListener('click', () => { set(false); tg.focus(); });
    pop.addEventListener('keydown', (e) => { if (e.key === 'Escape') { set(false); tg.focus(); } });
    document.addEventListener('yo:wa-open', () => set(true));
    $$('[data-wa-open-page]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); set(true); }));
  }

  /* ---------- Hero slider (cortina, zoom, barras, swipe) ---------- */
  class YoHero extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.hero__slide', this);
      this.bars = $$('.hero__bar', this);
      this.n = this.slides.length; this.cur = 0; this.busy = false;
      this.interval = parseInt(this.dataset.interval, 10) || 7000;
      this.dur = reduced ? 0 : 1800;
      if (this.n < 2) return;
      this.bars.forEach((b, i) => b.addEventListener('click', () => { this.go(i); }));
      this.addEventListener('mouseenter', () => this.pause(true));
      this.addEventListener('mouseleave', () => this.pause(false));
      this.addEventListener('focusin', () => this.pause(true));
      this.addEventListener('focusout', () => this.pause(false));
      let x = null;
      this.addEventListener('touchstart', (e) => { x = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x == null) return; const dx = e.changedTouches[0].clientX - x; x = null;
        if (Math.abs(dx) > 40) this.go(this.cur + (dx < 0 ? 1 : -1));
      });
      document.addEventListener('visibilitychange', () => this.pause(document.hidden));
      this.schedule();
    }
    schedule() { clearTimeout(this.t); if (this.paused || reduced) return; this.t = setTimeout(() => this.go(this.cur + 1), this.interval); }
    pause(p) {
      this.paused = p; this.classList.toggle('is-paused', p);
      if (p) clearTimeout(this.t); else { this.restartBar(); this.schedule(); }
    }
    restartBar() { const b = this.bars[this.cur]; if (!b) return; b.classList.remove('is-active'); void b.offsetWidth; b.classList.add('is-active'); }
    go(i) {
      if (this.busy) return;
      const next = ((i % this.n) + this.n) % this.n; if (next === this.cur) return;
      this.busy = true; this.classList.remove('is-first');
      const prev = this.slides[this.cur], cur = this.slides[next];
      this.slides.forEach((s) => s.classList.remove('is-prev'));
      prev.classList.remove('is-current'); prev.classList.add('is-prev'); prev.setAttribute('aria-hidden', 'true');
      cur.classList.add('is-entering'); cur.setAttribute('aria-hidden', 'false');
      const lazy = cur.querySelector('img[loading="lazy"]'); if (lazy) lazy.loading = 'eager';
      void cur.offsetWidth;
      cur.classList.add('is-current');
      this.bars.forEach((b, k) => { b.classList.toggle('is-active', k === next); b.setAttribute('aria-current', k === next ? 'true' : 'false'); });
      this.cur = next;
      setTimeout(() => { prev.classList.remove('is-prev'); cur.classList.remove('is-entering'); this.busy = false; }, this.dur + 60);
      this.schedule();
    }
  }
  customElements.define('yo-hero', YoHero);

  /* ---------- Galería de fotos (scroll-snap, flechas, puntos, avance automático) ---------- */
  class YoGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('.vgal__track', this);
      this.slides = $$('.vgal__slide', this);
      this.dots = $$('.vgal__dot', this);
      this.n = this.slides.length; this.cur = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      if (this.n < 2) return;
      $('[data-gal-prev]', this).addEventListener('click', () => this.go(this.cur - 1));
      $('[data-gal-next]', this).addEventListener('click', () => this.go(this.cur + 1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.cur - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.cur + 1); }
      });
      // Marca la foto al terminar el desplazamiento (swipe): durante el scroll suave los puntos parpadeaban.
      let quieto = 0;
      this.track.addEventListener('scroll', () => {
        clearTimeout(quieto);
        quieto = setTimeout(() => this.mark(Math.round(this.track.scrollLeft / this.track.clientWidth)), 150);
      }, { passive: true });
      // Avanza solo mientras se ve y nadie la está usando.
      this.hold = { hover: false, focus: false, touch: false, off: true };
      this.addEventListener('mouseenter', () => this.pause('hover', true));
      this.addEventListener('mouseleave', () => this.pause('hover', false));
      this.addEventListener('focusin', (e) => this.pause('focus', e.target.matches(':focus-visible')));
      this.addEventListener('focusout', () => this.pause('focus', false));
      this.track.addEventListener('touchstart', () => this.pause('touch', true), { passive: true });
      this.track.addEventListener('touchend', () => setTimeout(() => this.pause('touch', false), 2500), { passive: true });
      document.addEventListener('visibilitychange', () => this.schedule());
      if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => this.pause('off', !e.isIntersecting), { threshold: 0.4 }).observe(this);
    }
    pause(k, v) { this.hold[k] = v; this.schedule(); }
    schedule() {
      clearTimeout(this.t);
      if (reduced || document.hidden || Object.values(this.hold).some(Boolean)) return;
      this.t = setTimeout(() => this.go(this.cur + 1), this.interval);
    }
    mark(i) {
      if (i < 0 || i >= this.n) return;
      this.cur = i;
      this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      this.schedule();
    }
    go(i) {
      const next = ((i % this.n) + this.n) % this.n;
      const lazy = this.slides[next].querySelector('img[loading="lazy"]'); if (lazy) lazy.loading = 'eager';
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      this.mark(next);
    }
  }
  customElements.define('yo-gallery', YoGallery);

  /* ---------- Revelado al entrar en pantalla (frase de marca) ---------- */
  const reveal = $$('[data-reveal]');
  if (reveal.length) {
    if (!('IntersectionObserver' in window) || reduced) reveal.forEach((el) => el.classList.add('is-on'));
    else {
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-on'); io.unobserve(e.target); } }), { threshold: 0.35 });
      reveal.forEach((el) => io.observe(el));
    }
  }

  /* ---------- Secciones diferidas (más vendidos, recomendados) ---------- */
  const loadLazy = async (el) => {
    try {
      const res = await fetch(el.dataset.lazyUrl);
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const inner = doc.querySelector(el.dataset.lazySelector || '[data-lazy-content]');
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; el.removeAttribute('aria-busy'); }
      else if (el.dataset.lazyHideEmpty) { const h = el.closest(el.dataset.lazyHideEmpty); if (h) h.hidden = true; }
    } catch (err) { el.removeAttribute('aria-busy'); }
  };
  const lazies = $$('[data-lazy-url]');
  if (lazies.length) {
    if (!('IntersectionObserver' in window)) lazies.forEach(loadLazy);
    else {
      const io2 = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io2.unobserve(e.target); loadLazy(e.target); } }), { rootMargin: '600px 0px' });
      lazies.forEach((el) => io2.observe(el));
    }
  }

  /* ---------- Acordeones (details) exclusivos ---------- */
  document.addEventListener('toggle', (e) => {
    const d = e.target; if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    const g = d.dataset.group; if (!g) return;
    $$(`details[data-group="${g}"]`).forEach((o) => { if (o !== d) o.open = false; });
  }, true);
})();
